import React from 'react';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioButtonProps {
  options: RadioOption[];
  name: string;
  selectedValue: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({ options, name, selectedValue, onChange }) => {
  return (
    <div className="flex flex-row justify-between py-1">
      {options.map(option => (
        <label key={option.value} className="flex items-center cursor-pointer">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={onChange}
            className="hidden"
          />
          <span
            className={`w-4 h-4 mr-2 border-2 rounded-full flex items-center justify-center ${selectedValue === option.value ? 'bg-green-600 border-green-600' : 'border-gray-400'} hover:border-green-400 focus:border-green-500 transition-colors`}
          >
            {selectedValue === option.value && (
              <span className="w-1 h-1 bg-green-400 rounded-full "></span>
            )}
          </span>
          <span className="text-gray-800 text-[12px] dark:text-slate-400 font-normal">{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default RadioButton;
